import { useQuery } from "react-query";
import { getAllFaqs, getFaqsByTags, getHelpArticleByUID, getHelpArticles, getHelpSearchableDocuments } from "api/prismic";

export const helpKeys = {
  articles: () => ["help-articles"],
  article: (uid) => ["help-article", uid],
  searchableDocuments: () => ["help-searchable-documents"],
  faqsByTags: (andTags, orTags, notTags) => ["faqs-by-tags", andTags, orTags, notTags],
  allFaqs: () => ["all-faqs"],
};

export function useGetHelpArticles(config) {
  return useQuery(helpKeys.articles(), getHelpArticles, config);
}

export function useGetHelpArticle(uid, config) {
  return useQuery(helpKeys.article(uid), () => getHelpArticleByUID(uid), {
    enabled: !!uid,
    ...config,
  });
}

// Every Help page type — help_article ("Help Home"), help_guide, help_hub — in one
// list, for the Help section's search bar and for resolving a search result's UID
// back to its full document (see HelpPage.jsx).
export function useGetHelpSearchableDocuments(config) {
  return useQuery(helpKeys.searchableDocuments(), getHelpSearchableDocuments, config);
}

export function useGetFaqsByTags({ andTags = [], orTags = [], notTags = [] } = {}, config) {
  return useQuery(
    helpKeys.faqsByTags(andTags, orTags, notTags),
    () => getFaqsByTags({ andTags, orTags, notTags }),
    config
  );
}

export function useGetAllFaqs(config) {
  return useQuery(helpKeys.allFaqs(), getAllFaqs, config);
}
